import { toFixedWithoutRounding } from "@constants/common";
import useExchangeRate from "./useExchangeRate";

const useEthConversion = (assetConversionRate: any) => {
  const { exchangeRate: exchangeRateRsEthToEth } = useExchangeRate("ethRsEth");

  const valueInEth =
    assetConversionRate &&
    !isNaN(Number(assetConversionRate)) &&
    Number(assetConversionRate) > 0 &&
    exchangeRateRsEthToEth > 0
      ? toFixedWithoutRounding(
          (Number(assetConversionRate) * exchangeRateRsEthToEth)?.toString(),
          4
        )
      : "-";

  return {
    valueInEth,
  };
};

export default useEthConversion;
